'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = oauth;

var _immutable = require('immutable');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

var _OAuthActionTypes = require('../actionTypes/OAuthActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var INITIAL_STATE = new _immutable.Map({
  idToken: null,
  googleOAuthRequestState: RequestState.NOT_REQUESTED
});

function oauth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _OAuthActionTypes.REQUEST_GOOGLE_OAUTH_VERIFY:
      return state.set('googleOAuthRequestState', RequestState.REQUESTED);
    case _OAuthActionTypes.SUCCEED_GOOGLE_OAUTH_VERIFY:
      return state.set('googleOAuthRequestState', RequestState.SUCCEEDED);
    case _OAuthActionTypes.RECEIVE_OAUTH_ID_TOKEN:
      return state.set('idToken', payload.idToken);
    case _OAuthActionTypes.FAIL_GOOGLE_OAUTH_VERIFY:
      return state.set('googleOAuthRequestState', RequestState.FAILED);
    default:
      return state;
  }
}
module.exports = exports['default'];